import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserCountComponent } from './user-count.component';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core.module';
import { CountTabComponent } from './count-tab/count-tab.component';
import { UserCountTabComponent } from './user-count-tab/user-count-tab.component';
import { RoleCountTabComponent } from './role-count-tab/role-count-tab.component';
import { UserListGridComponent } from './role-count-tab/user-list-grid/user-list-grid.component';

@NgModule({
    imports: [
        CommonModule, CoreModule, SharedModule
    ],
    declarations: [
        UserCountComponent,
        CountTabComponent,
        UserCountTabComponent,
        RoleCountTabComponent,
        UserListGridComponent
    ],
    exports: [
        UserCountComponent
    ]
})
export class UserCountModule { }
